module.exports = __webpack_public_path__ + "img/new_12.8cdfbf43.jpg";